import React from 'react';
import { Users, Target, Award } from 'lucide-react';
import { mockData } from '../data/mock';

const iconMap = {
  Users: Users,
  Target: Target,
  Award: Award,
};

const Services = () => {
  return (
    <section id="services" style={styles.section}>
      <div className="container">
        <h2 className="heading-1" style={styles.title}>Was Sie erwartet</h2>
        <p className="body-large" style={styles.subtitle}>
          Ein ganzheitliches 2-Wochen-Programm für nachhaltigen Erfolg
        </p>
        
        <div style={styles.grid}>
          {mockData.services.map((service) => {
            const Icon = iconMap[service.icon];
            return (
              <div key={service.id} className="wahr-card" style={styles.card}>
                <div style={styles.iconWrapper}>
                  <Icon size={32} color="var(--brand-primary)" />
                </div>
                <h3 className="heading-3" style={styles.cardTitle}>{service.title}</h3>
                <p className="body-medium" style={styles.cardDescription}>
                  {service.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

const styles = {
  section: {
    padding: '80px 0',
    background: 'var(--bg-subtle)',
  },
  title: {
    textAlign: 'center',
    marginBottom: '16px',
  },
  subtitle: {
    textAlign: 'center',
    marginBottom: '56px',
    color: 'var(--text-secondary)',
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
    gap: '32px',
    maxWidth: '1200px',
    margin: '0 auto',
  },
  card: {
    textAlign: 'center',
  },
  iconWrapper: {
    width: '64px',
    height: '64px',
    background: 'rgba(75, 149, 209, 0.1)',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto 24px',
  },
  cardTitle: {
    marginBottom: '16px',
  },
  cardDescription: {
    color: 'var(--text-secondary)',
  },
};

export default Services;